import { useTranslation } from 'react-i18next'
import {
  CurecallTimelineLine,
  CurecallTimelineMessageItem,
  ECurecallTimelineMessageItemAppearance,
} from '@honestica/curecall-ui'
import { getTranslatedLabel } from 'src/utils/locale.util'
import {
  TTimeline,
  TTimelineMedEventElement,
  TTimelineMessageElement,
  TTimelineChatbotElement,
  ETimelineElementType,
} from './followup-timeline.type'
import { TimelineMedEventItem } from './timeline-med-event-item.component'
import { TimelineMessageItem } from './timeline-message-item.component'
import { TimelineChatbotItem } from './timeline-chatbot-item.component'
import { useLocale } from 'src/hooks/use-locale'

type FollowupTimelineProps = {
  timelineMedEventsSorted: TTimeline
  itemLabelBeingAdded?: string
}

export const FollowupTimeline = ({ itemLabelBeingAdded, timelineMedEventsSorted }: FollowupTimelineProps) => {
  const { locale } = useLocale()
  const { t } = useTranslation()

  if (timelineMedEventsSorted.length === 0) {
    return null
  }

  return (
    <div className="c-pr-4 c-min-w-72 c-w-72 c-max-w-72 c-pb-20 c-h-min">
      <h2 className="c-text-base c-font-bold">{t('pages.configuration.followups.title')}</h2>
      <div className="c-mt-4 c-relative c-max-w-full">
        <CurecallTimelineLine hasArrowTop={true} />
        {itemLabelBeingAdded && (
          <>
            <CurecallTimelineMessageItem appearance={ECurecallTimelineMessageItemAppearance.BOUNCING}>
              {itemLabelBeingAdded}
            </CurecallTimelineMessageItem>
            <CurecallTimelineLine />
          </>
        )}
        {timelineMedEventsSorted?.map((medEventTimeline) => {
          return medEventTimeline.map((timelineElement) => {
            if (timelineElement.type === ETimelineElementType.MED_EVENT) {
              return (
                <TimelineMedEventItem
                  key={`timeline-medevent-${getTranslatedLabel(locale, timelineElement.medEventLabel)}`}
                  timelineElement={timelineElement}
                />
              )
            }

            const correspondingMedEventLabel = (
              medEventTimeline.find(
                (element) => element.type === ETimelineElementType.MED_EVENT,
              ) as TTimelineMedEventElement
            ).medEventLabel
            const medEventName = correspondingMedEventLabel
              ? getTranslatedLabel(locale, correspondingMedEventLabel)
              : ''

            if (timelineElement.type === ETimelineElementType.CHATBOT) {
              return (
                <TimelineChatbotItem
                  key={`timeline-chatbot-${timelineElement.id}`}
                  timelineElement={timelineElement as TTimelineChatbotElement}
                  correspondingMedEventName={medEventName}
                />
              )
            }

            return (
              <TimelineMessageItem
                key={`timeline-message-${timelineElement.id}`}
                timelineElement={timelineElement as TTimelineMessageElement}
                correspondingMedEventName={medEventName}
              />
            )
          })
        })}
      </div>
    </div>
  )
}

FollowupTimeline.displayName = 'FollowupTimeline'
